import { formatCompactNumber } from "./palette";

const LONG_HEX_PATTERN = /^(0x)?[0-9a-fA-F]{16,}$/;

function truncateHex(value: string): string {
	const prefix = value.startsWith("0x") ? "0x" : "";
	const body = prefix ? value.slice(2) : value;
	if (body.length <= 12) return value;
	return `${prefix}${body.slice(0, 6)}…${body.slice(-4)}`;
}

export interface FormattedCell {
	display: string;
	full: string | null;
}

export function formatCellValue(value: unknown): FormattedCell {
	if (value === null || value === undefined || value === "")
		return { display: "–", full: null };
	if (typeof value === "number")
		return { display: formatCompactNumber(value), full: null };
	if (typeof value === "boolean")
		return { display: value ? "true" : "false", full: null };
	const str = String(value);
	if (LONG_HEX_PATTERN.test(str)) {
		return { display: truncateHex(str), full: str };
	}
	return { display: str, full: null };
}

// snake_case / lowercase column names -> "Sentence case" labels for card UIs.
export function humanizeLabel(col: string): string {
	const spaced = col.replace(/_/g, " ");
	return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

const PNL_COLUMN_PATTERN = /pnl|profit|loss/i;

export function isPnlColumn(col: string): boolean {
	return PNL_COLUMN_PATTERN.test(col);
}

// Fixed status hues (never themed, never reused for series identity).
export const STATUS_COLORS = {
	good: "#0ca30c",
	critical: "#d03b3b",
};

export function pnlColor(col: string, value: unknown): string | undefined {
	if (typeof value !== "number" || !isPnlColumn(col)) return undefined;
	if (value > 0) return STATUS_COLORS.good;
	if (value < 0) return STATUS_COLORS.critical;
	return undefined;
}
